svg {
  display: block;
  width: 20px;
  height: 20px;
  max-width: 100%;
  max-height: 100%;
}

svg.circle {
  width: 30px;
  height: 30px;
}

svg:hover {

  .social-fill {
    fill: var(--primary);
  }

  &.facebook .social-fill {
    fill: #3b5998;
  }

  &.twitter .social-fill {
    fill: #1DA1F2;
  }

  &.instagram .social-fill {
    fill: url(#brand-gradient);
  }

  &.pinterest .social-fill {
    fill: #c8232c;
  }

  &.linkedin .social-fill {
    fill: #0072b1;
  }

  &.youtube .social-fill {
    fill: #c4302b;
  }
}
